import { useState, useEffect } from "react";
import "./style.css"
import API from '../../utils/API';
import Swal from 'sweetalert2';
import Loader from "../Loader";

function EuiFactor(props) {
    const [edit, setEdit] = useState(false)
    const [value, setValue] = useState({
        "eui_building_type_id": props.modelId,
        "factor": "",
        "start_date": "",
    })
    const [acceptable, setAcceptable] = useState(false)
    // const [error, setError] = useState(null)
    const [loading, setLoading] = useState(null)

    useEffect(() => {
        if (!props.value) return
        setValue(props.value)
    }, [props])

    const updateValue = (e) => {
        const { name, value } = e.target;
        setValue(prevValue => {
            return {
                ...prevValue,
                [name]: value.trim()
            }
        })
    }

    useEffect(() => {
        let mandatory = ['start_date', 'factor']

        for (let item of mandatory) {
            if (value[item] !== '') continue
            setAcceptable(false)
            return
        }
        setAcceptable(true)

    }, [value])

    const postValue = async (e) => {

        let tempValue = { ...value }
        const toFormat = ['factor']

        for (let item of toFormat) {
            tempValue[item] = tempValue[item] ? parseFloat(tempValue[item]).toFixed(6) : tempValue[item]
        }
        tempValue.start_date = tempValue.start_date.split("T")[0]
        setLoading(true)
        const cancelToken = API.cancelToken();

        try {
            if (props.edit) {
                await API.postEuiFactor(cancelToken, tempValue)
            } else if (edit) {
                let payload = Object.fromEntries(Object.entries(tempValue).filter(([k]) => ['factor', 'start_date'].includes(k)));
                await API.putEuiFactor(cancelToken, value.id, payload)
            }
            if (props.edit) props.open(false)
            setEdit(false)
            props.setUpdate(!props.update)
        } catch (err) {
            console.log(err)
            if (err.message === 'cancelling') return
            if (err.response && err.response.data) {
                try {
                    if ('general' in err.response.data || 'message' in err.response.data) {
                        Swal.fire({
                            title: 'Error.',
                            text: err.response.data.general,
                            icon: 'warning',
                            confirmButtonText: 'Ok',
                            confirmButtonColor: '#007b4e',
                        });
                    }
                } catch (e) {
                    Swal.fire({
                        title: 'Error.',
                        text: err.response.data,
                        icon: 'warning',
                        confirmButtonText: 'Ok',
                        confirmButtonColor: '#007b4e',
                    });
                }
            } else {
                Swal.fire({
                    title: 'Error.',
                    text: 'An error occurred, please try again later.',
                    icon: 'warning',
                    confirmButtonText: 'Ok',
                    confirmButtonColor: '#007b4e',
                });
            }
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className='w-full flex flex-nowrap items-centery justify-between input-border p-4'>
            <div className='w-full flex p-4 gap-8'>
                <div className='tablet:w-2/12 mobile:w-full min-w-[100px] mb-4'>
                    <p className='text-xs mb-1'>Start Date</p>
                    <input
                        type="date"
                        name="start_date"
                        className='text-xs input-color outline-none w-full hide-input-background p-1'
                        defaultValue={value.start_date !== "" ? value.start_date.split('T')[0] : ""}
                        disabled={!props.edit && !edit}
                        onChange={updateValue} />
                </div>
                <div className='tablet:w-2/12 mobile:w-full min-w-[100px] mb-4'>
                    <p className='text-xs mb-1'>Amount</p>
                    <div className='flex flex-nowrap items-center'>
                        <input
                            placeholder='Amount'
                            className='hide-input-background text-sm input-color outline-none w-full p-1'
                            type="number"
                            step="0.1"
                            disabled={!props.edit && !edit}
                            name="factor"
                            defaultValue={value.factor !== "" ? value.factor : ""}
                            onChange={updateValue} />
                        <div>
                            <p className="text-xs mb-1">
                                GJ/m²/Year
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='tablet:w-2/12 mobile:w-full'>
                <div className='flex flex-nowrap items-center justify-end h-full'>
                    {
                        edit && !loading &&
                        <div className='mr-8 border-light-green block text-sm text-green4 font-medium cursor-pointer' onClick={() => setEdit(false)}>
                            Cancel
                        </div>
                    }
                    {
                        (props.edit || edit) && acceptable && !loading &&
                        <button className='submit-button-small' onClick={postValue}>
                            Save
                        </button>
                    }
                    {
                        (!props.edit && !edit) && acceptable && !loading &&
                        <button className='submit-button-small' onClick={() => setEdit(true)}>
                            Edit
                        </button>
                    }
                    {
                        (props.edit || edit) && loading &&
                        <Loader />
                    }
                </div>
            </div>
        </div>
    )
}

export default EuiFactor;
